<template lang="pug">
header
  .pre-head
    .logo
    .adress-block(class="address")
      div
        | Rakowiecka 70 , 50-422 Wrocław, &nbsp;
      div
        | tel.&nbsp;
        a.bold(href="tel:+48603135505") 603-135-505
  div(class="main-img")
  nav
    .hamburger(@click="opened = !opened" :class="{opened: opened}")
      span
      span
      span
      span
    ul( :class="{opened: opened}")
      li(v-for="route of getRoutes" :class="{active: $route.name === route.name}")
        router-link(:to="route.path") {{ route.name}}
</template>

<script>

export default {
  name: "Header",
  data() {
    return {
      opened: false
    }
  },
  computed: {
    getRoutes() {
      return this.$router.getRoutes()
    }
  }
}
</script>

